import { post, get } from '../network/index.js'

export default {
  // 查询适用店铺(分页)
  listStoreInfoByMercId: data => {
    return post('/mercWebi/busStoreInfo/listStoreInfoByMercId', data)
  },
  //下拉选择店铺
  getStoreDownList: data => {
    return post('/mercWebi/orderCode/getStoreDownList', data)
  },
  //查询适用店铺
  getApplicaStore: data => {
    return post('mercWebi/orderCode/getApplicaStore', data)
  },
  //根据店铺获取频道信息
  channalList: data => {
    return post('/mercWebi/attachment/channalList', data)
  },
  //店铺列表
  queryStoresListForMerc: data => {
    return post('/mercWebi/busStoreInfo/queryStoresListForMerc', data)
  },
  //新增店铺
  insertStoreForMerc: data => {
    return post('/mercWebi/busStoreInfo/insertStoreForMerc', data)
  },
  //获取店铺详情
  listStoreById: data => {
    return get('/mercWebi/busStoreInfo/listStoreById', data)
  },
  //修改店铺
  updateStoreForMerc: data => {
    return post('/mercWebi/busStoreInfo/updateStoreForMerc', data)
  },
  //删除店铺
  deleteStoreForMerc: data => {
    return post('/mercWebi/busStoreInfo/deleteStoreForMerc', data)
  },
  //修改打印机
  editPrinter: data => {
    return post('/mercWebi/busStoreInfo/editPrinter', data)
  },

  //店铺三方系统设置列表
  thirdConfigList: data => {
    return post('/mercWebi/storeThirdConfig/thirdConfigList', data)
  },
  //店铺三方系统设置删除
  deleteThirdConfig: data => {
    return post('/mercWebi/storeThirdConfig/deleteThirdConfig', data)
  },
  //店铺三方系统设置添加，编辑
  saveThirdConfig: data => {
    return post('/mercWebi/storeThirdConfig/saveThirdConfig', data)
  },
  //店铺码-生成
  generateStroeCode: data => {
    return post('/mercWebi/busStoreInfo/generateCode', data)
  },

  //店铺-查询智能设备
  querySmartDevice: data => {
    return post('/mercWebi/busStoreInfo/querySmartDevice', data)
  },
  //店铺-绑定智能设备
  bindSmartDevice: data => {
    return post('/mercWebi/busStoreInfo/bindSmartDevice', data)
  },
  //店铺-解绑智能设备
  unBindSmartDevice: data => {
    return post('/mercWebi/busStoreInfo/unBindSmartDevice', data)
  },

  //店铺-营业时间保存
  storeBusinessSave: data => {
    return post('/mercWebi/storeBusinessSet/save', data)
  },
  //店铺-营业时间列表
  storeBusinessList: data => {
    return post('/mercWebi/storeBusinessSet/queryList', data)
  },
  //店铺-营业时间删除
  storeBusinessDelete: data => {
    return post('/mercWebi/storeBusinessSet/deleteById', data)
  },
  //店铺-查询工厂店铺列表
  queryStoreFactoryList: data => {
    return post('/mercWebi/busStoreInfo/queryStoreFactoryList', data)
  },
  //店铺-店铺绑定工厂
  storeBindFactory: data => {
    return post('/mercWebi/busStoreInfo/bindFactory', data)
  },

  // 无人收衣舱店铺-绑定服务中心
  bindServiceStore: data => {
    return post('/mercWebi/busStoreInfo/bindServiceStore', data)
  },
  // 无人收衣舱店铺-解绑绑定服务中心
  unbindServiceStore: data => {
    return post('/mercWebi/busStoreInfo/unbindServiceStore', data)
  },

  // 商品提货店铺-绑定实体店铺（库存店铺）
  bindStockStore: data => {
    return post('/mercWebi/busStoreInfo/bindStockStore', data)
  },
  // 商品提货店铺-解绑实体店铺（库存店铺）
  unbindStockStore: data => {
    return post('/mercWebi/busStoreInfo/unbindStockStore', data)
  },

  // 查询外部工厂信息
  queryFactoryByStoreCode: data => {
    return post('/mercWebi/busStoreInfo/queryFactoryByStoreCode', data)
  },

  // 店铺-修改参数
  updateStoreParam: data => {
    return post('/mercWebi/busStoreInfo/updateStoreParam', data)
  },

  // 店铺-修改头图
  updateStoreHeadImg: data => {
    return post('/mercWebi/busStoreInfo/saveAppHeadImg', data)
  },
  // 店铺-修改展示图
  updateStoreShowImg: data => {
    return post('/mercWebi/busStoreInfo/saveShowImg', data)
  },
  // 店铺-删除展示图
  deleteStoreShowImg: data => {
    return post('/mercWebi/busStoreInfo/deleteShowImg', data)
  }
}
